import { defineVariants } from "@/runtime/style-engine/define-variants";

export const kbdClasses = defineVariants({
  base: `
    inline-flex! flex-row! w-auto!
    items-center justify-center gap-0!
    font-mono font-medium
    border-b-2! border-b-(--card-color)/50!
    py-0! rounded!
    select-none transition-colors
  `,

  variants: {
    color: {
      primary: ``,
      secondary: ``,
      accent: ``,
      error: ``,
      warning: ``,
      info: ``,
      success: ``,
      neutral: ``,
      mono: ``,
    },

    variant: {
      subtle: ``,
      solid: ``,
    },

    size: {
      xs: `text-xs h-[20px] px-1! min-w-[20px]`,
      sm: `text-sm h-[24px] px-1.5! min-w-[24px]`,
      md: `text-sm h-[30px] px-2! min-w-[30px]`,
      lg: `text-base h-[32px] px-2.5! min-w-[32px]`,
      xl: `text-lg h-[36px] px-3! min-w-[36px]`,
    },

    square: {
      true: `aspect-square px-0!`,
      false: ``,
    },
  },

  defaults: {
    color: "neutral",
    variant: "subtle",
    size: "md",
    square: "false",
  },

  compoundVariants: [
    { variant: "solid", color: "primary", class: "border-b-(--color-primary-elevation-700)!" },
    { variant: "solid", color: "secondary", class: "border-b-(--color-secondary-elevation-700)!" },
    { variant: "solid", color: "accent", class: "border-b-(--color-accent-elevation-700)!" },
    { variant: "solid", color: "error", class: "border-b-(--color-error-elevation-700)!" },
    { variant: "solid", color: "warning", class: "border-b-(--color-warning-elevation-700)!" },
    { variant: "solid", color: "info", class: "border-b-(--color-info-elevation-700)!" },
    { variant: "solid", color: "success", class: "border-b-(--color-success-elevation-700)!" },
    { variant: "solid", color: "neutral", class: "border-b-(--color-elevation-400)!" },
    { variant: "solid", color: "mono", class: "border-b-(--color-elevation-50)/40!" },
  ],
});
